import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType } from '@stackflow/react';
import { terminateApp } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        AppTerminationModal: {};
    }
}

const AppTerminationModal: ActivityComponentType<'AppTerminationModal'> = () => {
    const { t } = useTranslation('appTermination');
    const handleTermination = () => {
        terminateApp();
    };
    return (
        <AppModal deny={t('cancel')}
            confirm={t('confirm')}
            onConfirm={handleTermination} >
            <Text size='title' align='center'>
                {t('message')}
            </Text>
        </AppModal>
    );
};

export default AppTerminationModal;
